import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09359903"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__container" }
const _hoisted_2 = { class: "__identifier" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "__title" }
const _hoisted_5 = { class: "__main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pause" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: 
          _ctx.current_song.cover
            ? _ctx.current_song.cover
            : 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/7c95ff105413925.5f788730616d6.jpg'
        ,
        alt: _ctx.current_song.song_title
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.current_song.song_title ? _ctx.current_song.song_title : 'No Song Played'), 1),
        _createElementVNode("small", null, _toDisplayString(_ctx.current_song.song_artist ? _ctx.current_song.song_artist : '---'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.playing)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSong && _ctx.toggleSong(...args)), ["prevent"]))
          }, _hoisted_7))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSong && _ctx.toggleSong(...args)), ["prevent"]))
          }, _hoisted_9)),
      _createElementVNode("small", null, _toDisplayString(_ctx.seek), 1),
      _createElementVNode("div", {
        class: "__scrub",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSeek && _ctx.updateSeek(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", {
          class: "__player__ball",
          style: _normalizeStyle({ left: _ctx.playerProgress })
        }, _hoisted_11, 4),
        _createElementVNode("div", {
          class: "__progress__bar",
          style: _normalizeStyle({ width: _ctx.playerProgress })
        }, null, 4)
      ]),
      _createElementVNode("small", null, _toDisplayString(_ctx.duration), 1)
    ])
  ]))
}